import { MemberRole } from "features/team/model/types/members"

import { hasAccess } from "./access"

export const checkPermission = (userRole: MemberRole, rolesWithAccess: MemberRole[], permissionEnabled: boolean, isPublicLink: boolean) => {
  if(isPublicLink) {
    return permissionEnabled
  }
  return hasAccess(userRole, rolesWithAccess)
}